export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-mobile-signal-e1583c1d42d87bcba66d700baa864f1a.svg";